import React from 'react'
import Main from '../../organisms/Main/Main';

function LivingRoom() {
  return <Main title='Salon' category='livingroom' status='false' />;
}

export default LivingRoom